import { MobileModel } from "./Mobile.model";

export class Mobile extends MobileModel {
    // Add custom methods here
}
